import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import HomePage from "../Pages/HomePage/HomePage";
import Conditions from "../Components/Conditions/Conditions";
import HomePageHeader from "../Components/HomePageHeader/HomePageHeader";
import HomePageFooter from "../Components/HomePageFooter/HomePageFooter";
import IndustryPage from "../Pages/IndustryPage/IndustryPage";

const LayoutWrapper = ({ children }) => {
  const location = useLocation();

  const hideHeaderFooter = ["/Condition"];

  return (
    <>
      {!hideHeaderFooter.includes(location.pathname) && <HomePageHeader />}
      {children}
      {!hideHeaderFooter.includes(location.pathname) && <HomePageFooter />}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <LayoutWrapper>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/Condition" element={<Conditions />} />
          <Route path="/industry-page" element={<IndustryPage />} />
        </Routes>
      </LayoutWrapper>
    </Router>
  );
};

export default App;
